import { LOAD_USER_REFERRAL_IDENTIFIER_REQUEST, LOAD_USER_REFERRAL_IDENTIFIER_SUCCESS, LOAD_USER_REFERRAL_IDENTIFIER_ERROR, } from '../types';
export const loadUserReferralIdentifierRequest = () => ({
    type: LOAD_USER_REFERRAL_IDENTIFIER_REQUEST,
});
export const loadUserReferralIdentifierSuccess = (referralIdentifier) => ({
    type: LOAD_USER_REFERRAL_IDENTIFIER_SUCCESS,
    payload: {
        referralIdentifier,
    },
});
export const loadUserReferralIdentifierError = (error) => ({
    type: LOAD_USER_REFERRAL_IDENTIFIER_ERROR,
    payload: error,
    error: true,
});
export const loadUserReferralIdentifier = (options) => {
    return async (dispatch, _getState, { chord }) => {
        dispatch(loadUserReferralIdentifierRequest());
        try {
            const response = await chord.oms.getReferralIdentifier(options);
            dispatch(loadUserReferralIdentifierSuccess(response));
            return response;
        }
        catch (error) {
            dispatch(loadUserReferralIdentifierError(error));
            throw error;
        }
    };
};
export const getOrLoadUserReferralIdentifier = (options) => {
    return async (dispatch, getState) => {
        const { user } = getState();
        if (user.referralIdentifier)
            return user.referralIdentifier;
        return dispatch(loadUserReferralIdentifier(options));
    };
};
